import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { appStore } from "store";
import { getLocations, getCity } from "store/selectors";
import {
  sendPerformanceReview,
  updatePerformanceReview,
} from "./performanceReviewApi";
import { TextAreaInput } from "shared/components/TextAreaInput";
import css from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import { Text } from "shared/components/Text";
import { Button } from "shared/components/Button";
import { LoadingOverlay } from "shared/components/LoadingOverlay";
import { useSearchParams } from "react-router-dom";
export const PerformanceReviewPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const countryId = process.env.REACT_APP_COUNTRY_ID || "pl";
  const { locations } = appStore.useState(getLocations);
  const { city: cityFromStore } = appStore.useState(getCity);
  const [searchParams] = useSearchParams();
  const [number, setNumber] = useState(null);
  const [score, setScore] = useState(null);
  const [street, setStreet] = useState("");
  const [isInputVisible, setIsInputVisible] = useState(false);
  const [feedback, setFeedback] = useState("");
  const [city, setCity] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);
  const [reviewId, setReviewId] = useState(null);
  const [errorStatus, setErrorStatus] = useState(null);
  const [isSubmit, setIsSubmit] = useState(false);
  const [responseArrived, setResponseArrived] = useState(false);
  const handleSendReview = async ({
    number,
    score,
    city,
    street,
    countryId,
  }) => {
    if (!number || score === null) return;
    let res = {};
    try {
      res = await sendPerformanceReview({
        bookingNumber: number,
        score,
        city,
        street,
        country: countryId,
      });
      setReviewId(res.id);
    } catch (e) {
      console.error(e);
      setErrorStatus(e.response.status);
    } finally {
      setResponseArrived(true);
      return res;
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    setIsSubmit(true);
  };

  const handleFeedback = async () => {
    if (!number) return;
    try {
      await updatePerformanceReview({
        feedback: feedback.trim(),
        id: reviewId,
      });
    } catch (e) {
      console.error(e);
    }
    setIsInputVisible(false);
    setIsLoading(false);
    setIsSent(true);
  };

  useEffect(() => {
    const waitAndProceed = async () => {
      if (isSubmit) {
        if (!responseArrived) {
          return;
        }
        if (reviewId) {
          await handleFeedback();
        } else {
          setIsInputVisible(false);
          setIsSent(true);
          setIsLoading(false);
        }
        setIsSubmit(false);
      }
    };

    waitAndProceed();
  }, [isSubmit, reviewId, responseArrived]);

  useEffect(() => {
    const runEffect = async () => {
      const queryNumber = searchParams.get("number");
      const queryScore = parseInt(searchParams.get("score"));
      const resolvedCity =
        cityFromStore === "warszawa-box" ? "warszawa" : cityFromStore;
      const cityOptions = locations.cities[cityFromStore].cityOptions;

      if (
        !cityOptions.isPerformanceReviewEnabled ||
        !queryNumber ||
        isNaN(queryScore) ||
        queryScore > 10 ||
        queryScore < 0
      ) {
        navigate(`/${cityFromStore}`);
        return;
      }

      const newNumber = queryNumber;
      const newScore = queryScore;
      const newCity = resolvedCity;
      const newStreet = cityOptions.street || "";

      setNumber(newNumber);
      setScore(newScore);
      setStreet(newStreet);
      setCity(newCity);

      if (newScore <= 8) {
        setIsInputVisible(true);
      } else {
        setIsSent(true);
      }

      await handleSendReview({
        number: newNumber,
        score: newScore,
        city: newCity,
        street: newStreet,
        countryId: countryId,
      });
    };
    runEffect();
  }, []);

  return (
    <div className={css.PerformanceReview}>
      {isLoading && <LoadingOverlay />}
      {isInputVisible && !isLoading && (
        <>
          <Text type="white" bold size="subTitle">
            {t("performanceReview.question")}
          </Text>
          <div className={css.reviewContainer}>
            <TextAreaInput
              value={feedback}
              setValue={setFeedback}
              placeholder={t("performanceReview.yourAnswer")}
              className={css.textArea}
            />
            <Button
              onClick={handleSubmit}
              text={t("performanceReview.send")}
              disabled={isLoading}
            />
          </div>
        </>
      )}
      {isSent && !isInputVisible && (
        <Text type="white" bold size="subTitle">
          {t("performanceReview.thanks")}
        </Text>
      )}
    </div>
  );
};
